import { type FC, type ReactElement } from 'react';

import type { BadgeProps } from './props';

const Badge: FC<BadgeProps> = ({ type = 'success', extra, parentExtra, text }: BadgeProps): ReactElement | null => {
	const getBackgroundColor = () => {
		if (type == 'success') return 'bg-[#ccfbef]';
		if (type == 'info') return 'bg-[#d1f6ff]';
		if (type == 'warning') return 'bg-[#fff3c6]';
		if (type == 'danger') return 'bg-[#fee4e2]';
		if (type == 'theme') return 'bg-[#e4deff]';
	};
	const getTextColor = () => {
		if (type == 'success') return 'text-[#107469]';
		if (type == 'info') return 'text-[#27679c]';
		if (type == 'warning') return 'text-[#b84d04]';
		if (type == 'danger') return 'text-[#bb241b]';
		if (type == 'theme') return 'text-blueSecondary';
	};

	return (
		<div className={`${parentExtra ? parentExtra : ''}`}>
			<div
				className={`flex items-center justify-center rounded-lg px-2 py-1 text-center text-xs font-normal  ${getBackgroundColor()} ${getTextColor()} ${extra}`}>
				{text}
			</div>
		</div>
	);
};

export default Badge;
